import { useCallback } from 'react';
import { Grid2 as Grid, Typography } from '@mui/material';
import { CloseFormShowButton, EditFormShowButton, SaveFormShowButton, useFormShowContext } from 'framework/form';
import { useShowContext } from 'framework/show';
import { useProjectSecurityContext } from '../../context/ProjectSecurityContext';
import { TeamShowType } from '../types';
import { ACCESS_INFO_ACTIONS, ACCESS_INFO_SECTIONS } from '../../constants';
import ProjectSectionAccordion from '../../ProjectSectionAccordion';
import ProjectTeamForm from '../ProjectTeamForm';

const ProjectTeamList = () => {
  const { isEditMode } = useFormShowContext();
  const { isAccessGranted } = useProjectSecurityContext();
  const { data: allData } = useShowContext<TeamShowType>();

  const renderActions = useCallback(() => {
    if (
      isAccessGranted(ACCESS_INFO_SECTIONS.TEAM, ACCESS_INFO_ACTIONS.MANAGE) ||
      (isAccessGranted(ACCESS_INFO_SECTIONS.TEAM, ACCESS_INFO_ACTIONS.MANAGE) && !allData.isNeedCreateTeam)
    ) {
      return isEditMode
        ? [<SaveFormShowButton key="save" />, <CloseFormShowButton key="close" />]
        : [<EditFormShowButton key="edit" />];
    }
    return null;
  }, [isAccessGranted, allData.isNeedCreateTeam, isEditMode]);

  return (
    <ProjectSectionAccordion
      defaultExpanded
      title={
        <Grid container direction="row" justifyContent="space-between" alignItems="center" pl={2} width="100%">
          <Grid size={2}>
            <Typography variant="h4" color="primary">
              Team
            </Typography>
          </Grid>

          <Grid size="auto" alignItems="center" sx={{ '.filter-item-wrapper': { m: 0 } }} />

          <Grid size="grow" />

          <Grid size="auto" display="flex" alignItems="center">
            {renderActions()}
          </Grid>
        </Grid>
      }
    >
      <ProjectTeamForm />
    </ProjectSectionAccordion>
  );
};

export default ProjectTeamList;
